<!--
  @Description 批量输入框
  @Date 2021-01-04
  @Author liufu
-->
<template>
  <div>
    <vxe-modal
      v-model="formVisible"
      title="批量输入"
      width="400"
      :lock-scroll="false"
      @show="showModal"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        size="mini"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="40px" label="内容" prop="content">
              <!-- 别问为什么要加vif 因为高度会初始化 -->
              <el-input
                v-if="formVisible === true"
                type="textarea"
                v-model="form.content"
                autocomplete="off"
                placeholder="输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="buttonContainer">
          <el-button type="primary" size="mini" @click="sure">确认</el-button>
        </div>
      </el-form>
    </vxe-modal>
  </div>
</template>
<script>
export default {
  name: 'BatchInput',
  data () {
    return {
      // 是否显示
      formVisible: false,
      // 表单数据
      form: {
        content: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  methods: {
    showModal () {
      this.form = {
        content: ''
      }
    },
    sure () {
      this.$refs.form.validate((valuid) => {
        if (valuid) {
          this.$emit('sureHandler', this.form.content)
          this.formVisible = false
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.buttonContainer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
</style>
